import React, { useMemo } from "react";
import "../../../css/Praplanning/ParaplanningFields.css";
import CustomSelect from "../../DesignSystem/Dropdowns/CustomSelect";

const ParaplanningSelectField = ({
  label,
  required = false,
  value = "",
  onChange,
  options = [],
  placeholder = "Select option",
  disabled = false,
  error = "",
  clearable = true,
  searchable = true,
  searchPlaceholder = "Type to filter...",
}) => {
  const customSelectOptions = useMemo(() => {
    return options
      .map((option) => ({
        id: option.value ?? option.id ?? "",
        name: option.label ?? option.name ?? "",
      }))
      .filter((option) => option.id || option.name);
  }, [options]);

  return (
    <div className="ParaplanningField">
      {label && (
        <span className="ParaplanningField__Label">
          {label}
          {required && <span className="ParaplanningField__Required">*</span>}
        </span>
      )}

      <CustomSelect
        options={customSelectOptions}
        value={value || ""}
        disabled={disabled}
        error={!!error}
        placeholder={placeholder}
        clearable={clearable}
        searchable={searchable}
        searchPlaceholder={searchPlaceholder}
        onChange={(event) => onChange(event.target.value)}
      />

      {error && <span className="ParaplanningField__Error">{error}</span>}
    </div>
  );
};

export default ParaplanningSelectField;
